import React from 'react'

function NewBtn() {
  return (
    <a href="/content/new" className='NewBtn'>
    
        <h1>Create Lesson</h1>
    </a>
    
  )
}

export default NewBtn